import { render, staticRenderFns } from "./systemAlertsContent.vue?vue&type=template&id=d0071462&scoped=true"
import script from "./systemAlertsContent.vue?vue&type=script&lang=js"
export * from "./systemAlertsContent.vue?vue&type=script&lang=js"
import style0 from "./systemAlertsContent.vue?vue&type=style&index=0&id=d0071462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0071462",
  null
  
)

export default component.exports